var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssetDevicesEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#B1CBD9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3333 27.1666H38.0601C38.3455 27.1666 38.4881 27.1666 38.6224 27.1989C38.7415 27.2274 38.8553 27.2746 38.9596 27.3385C39.0774 27.4107 39.1783 27.5116 39.38 27.7134L44.1199 32.4532C44.3217 32.655 44.4226 32.7559 44.4947 32.8736C44.5587 32.978 44.6058 33.0918 44.6344 33.2109C44.6666 33.3451 44.6666 33.4878 44.6666 33.7732V37.0833C44.6666 37.6269 44.6666 37.8987 44.5778 38.1131C44.4594 38.399 44.2323 38.6261 43.9464 38.7445C43.732 38.8333 43.4602 38.8333 42.9166 38.8333M37.0833 38.8333H35.3333M35.3333 38.8333V27.4C35.3333 26.0932 35.3333 25.4398 35.079 24.9406C34.8553 24.5016 34.4983 24.1446 34.0593 23.9209C33.5602 23.6666 32.9068 23.6666 31.6 23.6666H25.0666C23.7599 23.6666 23.1065 23.6666 22.6073 23.9209C22.1683 24.1446 21.8113 24.5016 21.5876 24.9406C21.3333 25.4398 21.3333 26.0932 21.3333 27.4V36.5C21.3333 37.7886 22.378 38.8333 23.6666 38.8333M35.3333 38.8333H30.6666M30.6666 38.8333C30.6666 40.7663 29.0996 42.3333 27.1666 42.3333C25.2336 42.3333 23.6666 40.7663 23.6666 38.8333M30.6666 38.8333C30.6666 36.9003 29.0996 35.3333 27.1666 35.3333C25.2336 35.3333 23.6666 36.9003 23.6666 38.8333M42.9166 39.4166C42.9166 41.0275 41.6108 42.3333 40 42.3333C38.3891 42.3333 37.0833 41.0275 37.0833 39.4166C37.0833 37.8058 38.3891 36.5 40 36.5C41.6108 36.5 42.9166 37.8058 42.9166 39.4166Z",
    stroke: "#365A6D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#D0E0E8",
    strokeWidth: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetDevicesEmpty);
export default __webpack_public_path__ + "static/media/assetDevicesEmpty.9a0e54001e26bc8494ce96047d9e43b0.svg";
export { ForwardRef as ReactComponent };